import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";
import {LovListModel} from "../lovList.model";
import {LovListSummaryConverter} from "./lovListSummary.converter";

export class LovListConverter extends HttpModelConverter<LovListModel> {

    protected createInstance(): LovListModel {
        return new LovListModel();
    }

    protected enrichObject(result: LovListModel, src: LovListModel) {
        result.summary = new LovListSummaryConverter().convert(src.summary);
    }
}